<template>
  <div text-align:center>
    <h1>NFTstitches</h1>

    <h3></h3>
    <section class="section">
      <h2>Unlocking New Potential with NFTstitches</h2>
      <hr />
      <h3>
        NFTstitches are a revolutionary way to expand the capabilities of your
        existing NFTs. By seamlessly linking additional data and functionalities
        to your NFTs, they open up a world of possibilities across diverse
        industries.
      </h3>
      <h3>
        If you have an implementation of nftstiches, let us know so we can
        highlight it. An implementation of nftstiches can be found here:
        <a href="https://evidence.quest">Evidence.Quest</a>
      </h3>
    </section>
    <p></p>
    <hr />

    <p></p>
    <hr />
    <div class="wrapper">
      <div class="columns">
        <div class="columns"></div>
      </div>
    </div>

    <div class="wrapper">
      <h3>Example Use Cases</h3>
      <div class="columns">
        <div class="column">
          <ul>
            <li>
              <b>Food and Logistics:</b> An NFT for a prepackaged apple pie
              could have NFT links to each of its ingredients. A waybill NFT
              could be linked to the shipment of the apple pie NFT. A customer
              can write a review as an NFTstitch and have it link back to the
              specific NFT apple pie. If an ingredient NFT representing a batch
              of apples is later determined to be tainted, all of the linking
              products that used that ingredient can be easily identified as
              well as the shipments. As a producer, I can see that a particular
              shipment of apple pies all had similarly poor reviews.
            </li>
            <li>
              <b>Achievements and milestones:</b> NFTstitches could be used to
              commemorate milestones or achievements in a variety of contexts,
              such as leveling up, education, fitness, or personal development.
              By linking an NFTstitch to an existing NFT, you could create a
              tangible and verifiable record of the accomplishment. A university
              might provide an NFT representation for each completed course and
              a degree that has links to all of your NFT coursework.
            </li>
            <li>
              <b>Tracking Repairs and Events:</b> An NFT for a car could attach
              an NFTstitch for accidents, oil changes, brake replacement etc.
            </li>
            <li>
              <b>Loyalty rewards:</b> NFTstitches could be used as loyalty
              rewards in e-commerce or other businesses. For example, a retailer
              could issue NFTstitches to NFTs for repeat purchases or referrals,
              which bound to those original NFTs. The NFTs could be sold and
              would retain accumulated rewards.
            </li>
            <li>
              <b>Membership benefits:</b> NFTstitches could be used to provide
              special benefits or privileges to members of a group or
              organization. For example, a youtube channel about technical
              analysis could link an NFTstitch to the Blockchain Backer NFTs and
              offer them special promotions or varying benefits
            </li>
            <li>
              <b>Tracking Changes:</b> NFTstitches could be used to mark updates
              to the original NFT. For example, a realestate NFT with metadata
              stating 2 bathrooms could associate an NFTstitch marking an
              additional third bathroom was added at a later date.
            </li>
            <li>
              <b>Certificates of authenticity:</b> NFTstitches could be used to
              verify the authenticity of physical or digital items, such as
              artwork, collectibles, or other high-value goods. By linking an
              NFTstitch to an existing NFT, you could create a verifiable chains
              of data unrelated to ownership data currently stored on the
              ledger.
            </li>
          </ul>

          <h3>
            You can now create decentralized NFTs that link to other NFTs.
            <p>
              Various organizations can create different sets of NFTstitches
              linking to the same NFTs and have completely different use cases.
            </p>
            What use cases can you think of?
          </h3>
        </div>
        <div class="column">
          <img src="@/assets/images/applepie.jpg" width="300" class="center" />
          <p>
            <img
              src="@/assets/images/schoolbus_nftstitches.png"
              width="1200"
              class="center"
            />
          </p>
        </div>
      </div>
      <div>
        <hr />
        <div class="wrapper">
          <div class="columns">
            <div class="columns">
              <img
                src="@/assets/images/linked.png"
                width="600"
                class="center"
              />
            </div>
            <div class="column">
              This Warrior Bear NFT has been associated to several NFTstitches.
              One appears to be from a Fishing game, and another used by a
              Narwhal game. Toward the bottom appears to be one for some kind of
              Crypto Moon thing. The games are completely unrelated but the
              original NFT could be gaining some valuable benefits in each.
            </div>
          </div>
        </div>
        <p></p>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "overview",
  props: {
    msg: String,
  },
  components: {},
};
</script>

